import React, { useState } from 'react';
import { TermsModal } from './TermsModal';
import { PrivacyModal } from './PrivacyModal';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-[#2C3E50] text-white py-12" data-id="element-43">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-44">
          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-45">
            {/* Logo and description */}
            <div data-id="element-46">
              <div className="flex flex-wrap items-center gap-4 mb-4" data-id="element-47">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wVJCAiJMGndbNtF9B5KDzX/Logo_CEDES_Fondo_Trasparente_V2.0.png" alt="CEDES Logo" className="h-14 w-auto" data-id="element-48" />
                <img src="https://cdn.magicpatterns.com/uploads/qa7xrUCuvzFgSrAdyzsj42/logo_ticketmaestro_negativo.png" alt="TicketMaestro Logo" className="h-14 w-auto" data-id="element-49" />
                <img src="https://cdn.magicpatterns.com/uploads/jC6NC9dLpS7fdKxZ9Yo9Vv/logo_benefica_negativo.png" alt="Benefika Logo" className="h-14 w-auto" data-id="element-50" />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-51">
                TicketMaestro y su plataforma Benefika en colaboración con la
                Cámara Ecuatoriana de Emprendimiento y Desarrollo Sostenible
              </p>
            </div>

            {/* Quick links */}
            <div data-id="element-52">
              <h3 className="font-semibold text-lg mb-4" data-id="element-53">Enlaces rápidos</h3>
              <ul className="space-y-2 text-gray-300 text-sm" data-id="element-54">
                <li data-id="element-55">
                  <a href="https://www.cedes.ec/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5B9BD5] transition-colors" data-id="element-56">
                    Ir al sitio principal de CEDES
                  </a>
                </li>
                <li data-id="element-57">
                  <button onClick={() => setIsTermsOpen(true)} className="hover:text-[#5B9BD5] transition-colors text-left" data-id="element-58">
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-59">
                  <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-[#5B9BD5] transition-colors text-left" data-id="element-60">
                    Política de Privacidad
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-61">
              <h3 className="font-semibold text-lg mb-4" data-id="element-62">Contacto</h3>
              <ul className="space-y-2 text-gray-300 text-sm" data-id="element-63">
                <li data-id="element-64">
                  <a href="mailto:contacto@cedes.ec" className="hover:text-[#5B9BD5] transition-colors" data-id="element-65">
                    Email: contacto@cedes.ec
                  </a>
                </li>
                <li data-id="element-66">
                  <a href="https://wa.me/593980787857" target="_blank" rel="noopener noreferrer" className="hover:text-[#5B9BD5] transition-colors" data-id="element-67">
                    WhatsApp: +593 98 078 7857
                  </a>
                </li>
                <li data-id="element-68">
                  <a href="https://www.instagram.com/EmprendeFullpass" target="_blank" rel="noopener noreferrer" className="hover:text-[#5B9BD5] transition-colors" data-id="element-69">
                    Instagram: @EmprendeFullpass
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 text-center text-gray-400 text-sm" data-id="element-70">
            <p data-id="element-71">
              &copy; 2026 EmprendeFullPass es una marca de la Plataforma
              Benefika de TicketMaestro, en una iniciativa conjunto con la
              Cámara Ecuatoriana de Emprendimiento y Desarrollo Sostenible
              (CEDES). Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-72" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-73" />
    </>;
}